/**
 * Controlled collapsible card used across the report tabs. Open state is owned
 * by the parent DisclosureGroup so an "Expand all / Collapse all" control can
 * drive every card at once. Smooth height animation via a grid-rows trick
 * (no JS height measurement).
 */
import { ChevronDown } from "lucide-react";

export default function DisclosureCard({ title, badge, open, onToggle, testid, children }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white overflow-hidden" data-testid={testid}>
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        data-testid={testid ? `${testid}-trigger` : undefined}
        className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left hover:bg-slate-50 transition-colors"
      >
        <span className="flex items-center gap-3 min-w-0">
          <span className="font-display text-base font-semibold text-slate-900">{title}</span>
          {badge != null && badge !== "" && (
            <span className="shrink-0 text-[11px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-500 font-medium">{badge}</span>
          )}
        </span>
        <ChevronDown className={`h-4 w-4 text-slate-400 shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      <div className={`grid transition-all duration-200 ease-out ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
        <div className="overflow-hidden">
          <div className="px-5 pb-5 border-t border-slate-100 pt-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
